import { render, staticRenderFns } from "./inve-action-details.vue?vue&type=template&id=028477c9&"
import script from "./inve-action-details.vue?vue&type=script&lang=js&"
export * from "./inve-action-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports